import { createFetcher } from "@plerity/data-access";
import { API_BASE_URL } from "../config";
import { getEffectiveTenantId } from "../lib/admin";

/**
 * Social Media API client — uses shared createFetcher for consistent defaults.
 *
 * Multi-tenant scoping (X-Tenant-Id)
 * ----------------------------------
 * Every mutation in `api/mutations.ts` goes through THIS client. The business
 * selected via the admin org switcher writes a `selectedOrgId` to the admin
 * store; the backend's tenant middleware resolves that id to the active org.
 * We MUST send `X-Tenant-Id` here so mutations resolve to the SAME business
 * the queries (shared dashboard client, interceptor in `main.tsx`) are
 * scoped to — otherwise mutations silently fall back to the hostname-default
 * org for every non-default business. Mirrors the reviews app fix (Error KB
 * reviews-mutation-tenant-header-divergence, 2026-07-24).
 */
export const client = createFetcher({
  baseURL: API_BASE_URL,
  withCredentials: true,
  onRequest: (config) => {
    const selectedOrgId = getEffectiveTenantId();
    if (selectedOrgId !== null) {
      config.headers.set("X-Tenant-Id", String(selectedOrgId));
    }
    return config;
  },
});
